module.exports = __webpack_public_path__ + "static/media/review1_guide.1359732a.png";